import ServiceBase from '@/Services/ServiceBase';

export default class ImageService extends ServiceBase {
    uploadImage(formData) {
        return this.request('post', '/image', formData);
    }

    buildImageUrl(filename = null, preset, format = 'JPEG') {
        if (!filename) {
            return null;
        }

        const baseUrl = this.$http.defaults.baseURL;
        return `${baseUrl}/image/${preset}/${format}/${filename}`;
    }
}
